import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { RequisitoForm } from "features/projetos/pages/ProjetoEditPage/tabs/Requisitos/useAdicionarRequisitoModal";

async function createRequisito(data: RequisitoForm): Promise<IResponse<ValidationResult>> {
    return await axios.post('/Requisito/Create', data);
}

export default createRequisito;